import { render } from "./MailChangeComplete.vue?vue&type=template&id=145725ab&scoped=true"
import script from "./MailChangeComplete.vue?vue&type=script&lang=js"
export * from "./MailChangeComplete.vue?vue&type=script&lang=js"

import "./MailChangeComplete.vue?vue&type=style&index=0&id=145725ab&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-145725ab"]])

export default __exports__